module.exports = __webpack_public_path__ + "img/bg2.90c87346.jpg";